import Main from 'components/Main/Main';
import { AnalyticsProvider } from 'contexts/Analytics/Analytics';
import { initSentry } from 'setup/sentry';

initSentry();
import { ApiProvider } from 'contexts/Api/Api';
import { ContentProvider } from 'contexts/Content/Content';
import { GameProvider } from 'contexts/Game/Game';
import { PageProvider } from 'contexts/Page/Page';
import { SettingsProvider } from 'contexts/Settings/Settings';
import { SoundsProvider } from 'contexts/Sounds/Sounds';
import { ThemeProvider } from 'contexts/Theme/Theme';
import type { AppProps } from 'next/app';
import 'react-material-symbols/rounded';

export default function App({ Component, pageProps }: AppProps) {
    return (
        <AnalyticsProvider>
            <ThemeProvider>
                <SettingsProvider>
                    <ApiProvider>
                        <ContentProvider>
                            <SoundsProvider>
                                <PageProvider>
                                    <GameProvider>
                                        <Main>
                                            <Component {...pageProps} />
                                        </Main>
                                    </GameProvider>
                                </PageProvider>
                            </SoundsProvider>
                        </ContentProvider>
                    </ApiProvider>
                </SettingsProvider>
            </ThemeProvider>
        </AnalyticsProvider>
    );
}
